import React from "react";
import PropTypes from "prop-types";
import { ProgressBar as BootstrapProgressBar } from "react-bootstrap";

import addTaskUIProps from "../../containers/TaskUI/addTaskUIProps";

import "./ProgressBar.css";

export const ProgressBar = props => {
    const getSimpleProgressBar = () => {
        let progress = 0;
        if (props.amount !== 0) {
            progress = Math.floor(100 * (props.index / props.amount));
        }
        const style = {
            width: props.width
        };

        return (
            <div className="progress_bar_container" style={style}>
                <BootstrapProgressBar now={progress} />
                <label className="progress_bar_label">
                    {props.index}/{props.amount}
                </label>
            </div>
        );
    };

    return <>{getSimpleProgressBar()}</>;
};

ProgressBar.defaultProps = {
    width: "auto"
};

ProgressBar.propTypes = {
    index: PropTypes.number.isRequired,
    amount: PropTypes.number.isRequired,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

export const ConnectedProgressBar = addTaskUIProps(
    /**
     * A small wrapper component that uses the appropriate taskUI props for the progressbar
     *
     * @param {import("../../containers/TaskUI/addTaskUIProps").ConnectedTaskUIViewProps} props
     */
    ({ currentTaskIdx, tasksAmount, style }) => {
        if (tasksAmount <= 1) {
            return null;
        }

        const overriddenStyle = { ...style };
        return (
            <div className="progressbar_qm" style={overriddenStyle}>
                <ProgressBar index={currentTaskIdx + 1} amount={tasksAmount} />
            </div>
        );
    }
);

export default ProgressBar;
